export default __webpack_public_path__ + "static/media/footer5.9e9194e6.jpg";